var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5002 4.5H3.50016C2.0335 4.5 0.833496 5.7 0.833496 7.16667V12.9427H4.1615V16.5H14.8388V12.9427H18.1668V7.16667C18.1668 5.7 16.9668 4.5 15.5002 4.5ZM13.5002 15.1667H5.50016V9.83333H13.5002V15.1667ZM14.8388 0.5H4.1615V3.83333H14.8388V0.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.9ddc99030f381e6522c9da1c4dbe63b4.svg";
export { ForwardRef as ReactComponent };